import { Icon } from '@aon/aon-tws-common-ui';
import styled from 'styled-components';

export const WarningTextTitle = styled('div')`
	font-size: 16px;
`;
WarningTextTitle.displayName = 'WarningTextTitle';
export const WarningIcon = styled(Icon)`
	color: red;
`;
WarningIcon.displayName = 'WarningIcon';
export const WarningTextContainer = styled.div<{ maxWidth?: string }>`
	color: #ffffff;
	border-radius: 5px;
	max-width: ${(props) => props.maxWidth};
	background-color: #444444;
	margin-bottom: 20px;
	padding: 15px;
`;
WarningTextContainer.displayName = 'WarningTextContainer';
